<template>
  <div class="background">
    <v-layout align-center justify-center fill-height d-flex column>
      <v-progress-circular :rotate="-90" :size="150" :width="7" :value="value" color="warning" class="progress" v-show="showLoader">
        <div><img src="../assets/logo-e.svg" alt="Evntl" class="fillLogo" /></div>
      </v-progress-circular>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Loader',
  data() {
    return {
      value: 0
    };
  },
  computed: {
    ...mapGetters({
      generalGetMobileState: 'generalGetMobileState',
      generalGetSideDrawer: 'generalGetSideDrawer'
    }),
    showLoader() {
      if (this.generalGetMobileState) {
        if (this.generalGetSideDrawer) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  },
  async mounted() {
    await setInterval(() => {
      if (this.value >= 160) {
        this.value = 0;
      }
      this.value += 2.5;
    }, 100);
    clearInterval();
  }
};
</script>

<style scoped>
.fillLogo {
  margin-top: 0.5rem;
  width: 10rem;
  height: 10rem;
}
.background {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 3;
  background-color: #085280 !important;
}
</style>
